/**
 * Invitation
 */

import {backendUrl} from '@/assets/js/config'
import axios from '@/assets/plugins/axios'

// 验证企业邀请码
export const invitationValid = (params) => {
  return axios.get(`${backendUrl}/enterprise/invitation/valid`, params)
}

// 根据手机号+验证码拉取员工列表
export const getRecommendList = (params) => {
  return axios.post(`${backendUrl}/enterprise/invitation/join`, params)
}

// 创建新员工
export const createEmployee = (params) => {
  return axios.post(`${backendUrl}/enterprise/invitation/employee`, params)
}

// 绑定已有账号和未实名账号
export const bindingAccount = (params) => {
  return axios.put(`${backendUrl}/enterprise/invitation/used_account`, params)
}

// 绑定资产并创建账号
export const bindingAsset = (params) => {
  return axios.put(`${backendUrl}/enterprise/invitation/asset_account`, params)
}

// 绑定垃圾账号
export const bindingGarbageAccount = (params) => {
  return axios.put(`${backendUrl}/enterprise/invitation/garbage_account`, params)
}
